module.exports = __webpack_public_path__ + "static/stuff-matters-a9289e75df5e846f1306661e9d69224f.jpg";